import { RankingInfo } from "../types/RankingInfo";

export const RankInfos: RankingInfo[] = [
  {
    nr: 1,
    rank: "Nobody",
    promoteXP: 0,
    crimesReq: 0,
    carsNickReq: 0,
    boozeReq: 0,
    narcsReq: 0,
    crimesTimeDay: 0.0,
    carsTimeDay: 0.0,
    boozeSmuggTimeDay: 0.0,
    narcsSmuggTimeDay: 0.0,
    accumulatedXP: 0,
    minTime: 0.0,
    accTime: 0,
  },
  {
    nr: 2,
    rank: "Apprentice",
    promoteXP: 100,
    crimesReq: 20,
    carsNickReq: 10,
    boozeReq: 4,
    narcsReq: 2,
    crimesTimeDay: 0.4,
    carsTimeDay: 0.4,
    boozeSmuggTimeDay: 0.5,
    narcsSmuggTimeDay: 0.4,
    accumulatedXP: 100,
    minTime: 0.1,
    accTime: 0.1,
  },
  {
    nr: 3,
    rank: "Pickpocket",
    promoteXP: 200,
    crimesReq: 40,
    carsNickReq: 20,
    boozeReq: 8,
    narcsReq: 4,
    crimesTimeDay: 0.8,
    carsTimeDay: 0.8,
    boozeSmuggTimeDay: 1.0,
    narcsSmuggTimeDay: 0.7,
    accumulatedXP: 300,
    minTime: 0.3,
    accTime: 0.4,
  },
  {
    nr: 4,
    rank: "Cloak",
    promoteXP: 400,
    crimesReq: 80,
    carsNickReq: 40,
    boozeReq: 16,
    narcsReq: 9,
    crimesTimeDay: 1.7,
    carsTimeDay: 1.7,
    boozeSmuggTimeDay: 2.0,
    narcsSmuggTimeDay: 1.5,
    accumulatedXP: 600,
    minTime: 0.6,
    accTime: 0.9,
  },
  {
    nr: 5,
    rank: "Thief",
    promoteXP: 800,
    crimesReq: 160,
    carsNickReq: 80,
    boozeReq: 32,
    narcsReq: 18,
    crimesTimeDay: 3.3,
    carsTimeDay: 3.3,
    boozeSmuggTimeDay: 4.0,
    narcsSmuggTimeDay: 3.0,
    accumulatedXP: 1200,
    minTime: 1.3,
    accTime: 1.9,
  },
  {
    nr: 6,
    rank: "Locksmith",
    promoteXP: 1600,
    crimesReq: 320,
    carsNickReq: 160,
    boozeReq: 64,
    narcsReq: 36,
    crimesTimeDay: 6.7,
    carsTimeDay: 6.7,
    boozeSmuggTimeDay: 8.0,
    narcsSmuggTimeDay: 5.9,
    accumulatedXP: 2400,
    minTime: 2.5,
    accTime: 3.8,
  },
  {
    nr: 7,
    rank: "Runner",
    promoteXP: 1968,
    crimesReq: 394,
    carsNickReq: 197,
    boozeReq: 79,
    narcsReq: 44,
    crimesTimeDay: 8.2,
    carsTimeDay: 8.2,
    boozeSmuggTimeDay: 9.8,
    narcsSmuggTimeDay: 7.3,
    accumulatedXP: 3568,
    minTime: 3.8,
    accTime: 6.3,
  },
  {
    nr: 8,
    rank: "Associate",
    promoteXP: 2421,
    crimesReq: 484,
    carsNickReq: 242,
    boozeReq: 97,
    narcsReq: 54,
    crimesTimeDay: 10.1,
    carsTimeDay: 10.1,
    boozeSmuggTimeDay: 12.1,
    narcsSmuggTimeDay: 9.0,
    accumulatedXP: 4389,
    minTime: 4.6,
    accTime: 8.4,
  },
  {
    nr: 9,
    rank: "Dealer",
    promoteXP: 2977,
    crimesReq: 595,
    carsNickReq: 298,
    boozeReq: 119,
    narcsReq: 66,
    crimesTimeDay: 12.4,
    carsTimeDay: 12.4,
    boozeSmuggTimeDay: 14.9,
    narcsSmuggTimeDay: 11.0,
    accumulatedXP: 5398,
    minTime: 5.7,
    accTime: 10.3,
  },
  {
    nr: 10,
    rank: "Fixer",
    promoteXP: 3662,
    crimesReq: 732,
    carsNickReq: 366,
    boozeReq: 146,
    narcsReq: 81,
    crimesTimeDay: 15.3,
    carsTimeDay: 15.3,
    boozeSmuggTimeDay: 18.3,
    narcsSmuggTimeDay: 13.6,
    accumulatedXP: 6640,
    minTime: 7.0,
    accTime: 12.7,
  },
  {
    nr: 11,
    rank: "Collector",
    promoteXP: 4504,
    crimesReq: 901,
    carsNickReq: 450,
    boozeReq: 180,
    narcsReq: 100,
    crimesTimeDay: 18.8,
    carsTimeDay: 18.8,
    boozeSmuggTimeDay: 22.5,
    narcsSmuggTimeDay: 16.7,
    accumulatedXP: 8167,
    minTime: 8.6,
    accTime: 15.6,
  },
  {
    nr: 12,
    rank: "Enforcer",
    promoteXP: 5541,
    crimesReq: 1108,
    carsNickReq: 554,
    boozeReq: 222,
    narcsReq: 123,
    crimesTimeDay: 23.1,
    carsTimeDay: 23.1,
    boozeSmuggTimeDay: 27.7,
    narcsSmuggTimeDay: 20.5,
    accumulatedXP: 10045,
    minTime: 10.6,
    accTime: 19.2,
  },
  {
    nr: 13,
    rank: "Prospect",
    promoteXP: 6815,
    crimesReq: 1363,
    carsNickReq: 681,
    boozeReq: 273,
    narcsReq: 151,
    crimesTimeDay: 28.4,
    carsTimeDay: 28.4,
    boozeSmuggTimeDay: 34.1,
    narcsSmuggTimeDay: 25.2,
    accumulatedXP: 12355,
    minTime: 13.0,
    accTime: 23.6,
  },
  {
    nr: 14,
    rank: "Lieutenant",
    promoteXP: 8382,
    crimesReq: 1676,
    carsNickReq: 838,
    boozeReq: 335,
    narcsReq: 186,
    crimesTimeDay: 34.9,
    carsTimeDay: 34.9,
    boozeSmuggTimeDay: 41.9,
    narcsSmuggTimeDay: 31.0,
    accumulatedXP: 15197,
    minTime: 16.0,
    accTime: 29.0,
  },
  {
    nr: 15,
    rank: "Soldier",
    promoteXP: 10310,
    crimesReq: 2062,
    carsNickReq: 1031,
    boozeReq: 412,
    narcsReq: 229,
    crimesTimeDay: 43.0,
    carsTimeDay: 43.0,
    boozeSmuggTimeDay: 51.6,
    narcsSmuggTimeDay: 38.2,
    accumulatedXP: 18692,
    minTime: 19.7,
    accTime: 35.7,
  },
  {
    nr: 16,
    rank: "Mobster",
    promoteXP: 12682,
    crimesReq: 2536,
    carsNickReq: 1268,
    boozeReq: 507,
    narcsReq: 282,
    crimesTimeDay: 52.8,
    carsTimeDay: 52.8,
    boozeSmuggTimeDay: 63.4,
    narcsSmuggTimeDay: 47.0,
    accumulatedXP: 22992,
    minTime: 24.2,
    accTime: 43.9,
  },
  {
    nr: 17,
    rank: "Swindler",
    promoteXP: 15598,
    crimesReq: 3120,
    carsNickReq: 1560,
    boozeReq: 624,
    narcsReq: 347,
    crimesTimeDay: 65.0,
    carsTimeDay: 65.0,
    boozeSmuggTimeDay: 78.0,
    narcsSmuggTimeDay: 57.8,
    accumulatedXP: 28280,
    minTime: 29.8,
    accTime: 54.0,
  },
  {
    nr: 18,
    rank: "Whisperer",
    promoteXP: 19186,
    crimesReq: 3837,
    carsNickReq: 1919,
    boozeReq: 767,
    narcsReq: 426,
    crimesTimeDay: 79.9,
    carsTimeDay: 79.9,
    boozeSmuggTimeDay: 95.9,
    narcsSmuggTimeDay: 71.1,
    accumulatedXP: 34784,
    minTime: 36.6,
    accTime: 66.4,
  },
  {
    nr: 19,
    rank: "Architect",
    promoteXP: 23599,
    crimesReq: 4720,
    carsNickReq: 2360,
    boozeReq: 944,
    narcsReq: 524,
    crimesTimeDay: 98.3,
    carsTimeDay: 98.3,
    boozeSmuggTimeDay: 118.0,
    narcsSmuggTimeDay: 87.4,
    accumulatedXP: 42784,
    minTime: 45.0,
    accTime: 81.7,
  },
  {
    nr: 20,
    rank: "Hitman",
    promoteXP: 29026,
    crimesReq: 5805,
    carsNickReq: 2903,
    boozeReq: 1161,
    narcsReq: 645,
    crimesTimeDay: 120.9,
    carsTimeDay: 120.9,
    boozeSmuggTimeDay: 145.1,
    narcsSmuggTimeDay: 107.5,
    accumulatedXP: 52625,
    minTime: 55.4,
    accTime: 100.4,
  },
  {
    nr: 21,
    rank: "Assassin",
    promoteXP: 35702,
    crimesReq: 7140,
    carsNickReq: 3570,
    boozeReq: 1428,
    narcsReq: 793,
    crimesTimeDay: 148.8,
    carsTimeDay: 148.8,
    boozeSmuggTimeDay: 178.5,
    narcsSmuggTimeDay: 132.2,
    accumulatedXP: 64729,
    minTime: 68.1,
    accTime: 123.5,
  },
  {
    nr: 22,
    rank: "Commander",
    promoteXP: 43914,
    crimesReq: 8783,
    carsNickReq: 4391,
    boozeReq: 1757,
    narcsReq: 976,
    crimesTimeDay: 183.0,
    carsTimeDay: 183.0,
    boozeSmuggTimeDay: 219.6,
    narcsSmuggTimeDay: 162.6,
    accumulatedXP: 79616,
    minTime: 83.8,
    accTime: 151.9,
  },
  {
    nr: 23,
    rank: "Executioner",
    promoteXP: 54014,
    crimesReq: 10803,
    carsNickReq: 5401,
    boozeReq: 2161,
    narcsReq: 1200,
    crimesTimeDay: 225.1,
    carsTimeDay: 225.1,
    boozeSmuggTimeDay: 270.1,
    narcsSmuggTimeDay: 200.1,
    accumulatedXP: 97928,
    minTime: 103.1,
    accTime: 186.9,
  },
  {
    nr: 24,
    rank: "Widowmaker",
    promoteXP: 66437,
    crimesReq: 13287,
    carsNickReq: 6644,
    boozeReq: 2657,
    narcsReq: 1476,
    crimesTimeDay: 276.8,
    carsTimeDay: 276.8,
    boozeSmuggTimeDay: 332.2,
    narcsSmuggTimeDay: 246.1,
    accumulatedXP: 120451,
    minTime: 126.8,
    accTime: 229.9,
  },
  {
    nr: 25,
    rank: "Bone collector",
    promoteXP: 81718,
    crimesReq: 16344,
    carsNickReq: 8172,
    boozeReq: 3269,
    narcsReq: 1816,
    crimesTimeDay: 340.5,
    carsTimeDay: 340.5,
    boozeSmuggTimeDay: 408.6,
    narcsSmuggTimeDay: 302.7,
    accumulatedXP: 148155,
    minTime: 156.0,
    accTime: 282.7,
  },
  {
    nr: 26,
    rank: "Tactician",
    promoteXP: 100513,
    crimesReq: 20103,
    carsNickReq: 10051,
    boozeReq: 4021,
    narcsReq: 2234,
    crimesTimeDay: 418.8,
    carsTimeDay: 418.8,
    boozeSmuggTimeDay: 502.6,
    narcsSmuggTimeDay: 372.3,
    accumulatedXP: 182231,
    minTime: 191.8,
    accTime: 347.8,
  },
  {
    nr: 27,
    rank: "Chief",
    promoteXP: 123631,
    crimesReq: 24726,
    carsNickReq: 12363,
    boozeReq: 4945,
    narcsReq: 2747,
    crimesTimeDay: 515.1,
    carsTimeDay: 515.1,
    boozeSmuggTimeDay: 618.2,
    narcsSmuggTimeDay: 457.9,
    accumulatedXP: 224144,
    minTime: 235.9,
    accTime: 427.8,
  },
  {
    nr: 28,
    rank: "Warlord",
    promoteXP: 152066,
    crimesReq: 30413,
    carsNickReq: 15207,
    boozeReq: 6083,
    narcsReq: 3379,
    crimesTimeDay: 633.6,
    carsTimeDay: 633.6,
    boozeSmuggTimeDay: 760.3,
    narcsSmuggTimeDay: 563.2,
    accumulatedXP: 275697,
    minTime: 290.2,
    accTime: 526.1,
  },
  {
    nr: 29,
    rank: "Capo bastone",
    promoteXP: 187041,
    crimesReq: 37408,
    carsNickReq: 18704,
    boozeReq: 7482,
    narcsReq: 4156,
    crimesTimeDay: 779.3,
    carsTimeDay: 779.3,
    boozeSmuggTimeDay: 935.2,
    narcsSmuggTimeDay: 692.7,
    accumulatedXP: 339107,
    minTime: 357.0,
    accTime: 647.2,
  },
  {
    nr: 30,
    rank: "Godfather",
    promoteXP: 230061,
    crimesReq: 46012,
    carsNickReq: 23006,
    boozeReq: 9202,
    narcsReq: 5112,
    crimesTimeDay: 958.6,
    carsTimeDay: 958.6,
    boozeSmuggTimeDay: 1150.3,
    narcsSmuggTimeDay: 852.1,
    accumulatedXP: 417102,
    minTime: 439.1,
    accTime: 796.0,
  },
];
